import React from 'react';
import { EditableComponent } from '@adobe/aem-react-editable-components';

import { OCardMiniImage as OCardMiniImageComp } from '@marriott/mi-web-ui-kit';
import clsx from 'clsx';

export const OCardMiniImageConfig = {
  emptyLabel: 'OCardMiniImage',
  isEmpty: () => true,
  resourceType: `${process.env['NEXT_PUBLIC_AEM_SITE']}/components/content/o-card-mini-image`,
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const OCardMiniImage = (props: any) => {
  const model = props.model || {};
  const { styleclass, componentId } = model;

  return (
    <div
      data-testid="o-card-mini-image-comp"
      data-component-name="o-card-mini-image"
      id={componentId}
      className={clsx(styleclass)}
    >
      <EditableComponent config={OCardMiniImageConfig} {...props}>
        <OCardMiniImageComp {...props} />
      </EditableComponent>
    </div>
  );
};
